import * as React from 'react';
import * as styles from '../users.module.scss';
import { PaginatedUserContext } from '../../../../shared/paginated-user-context';
import Scrollbars from 'react-custom-scrollbars';
import UserEntry from './user-entry';
import User from '../../../../models/user';
import Table from '../../../table/table';
import TableHead from '../../../table/table-head';
import HeaderCell from '../../../table/table-header-cell';
import TableBody from '../../../table/table-body';
import { UserSortingOptions } from '../../../../models/enums/adminSortingOptions';
import usePaginatedUsers from '../../../../hooks/usePaginatedUsers';

interface Props {
  loading: boolean;
  setErrorMessage: (message: string) => void;
  setSuccessMessage: (message: string) => void;
}

const UserTable = ({ loading, setErrorMessage, setSuccessMessage }: Props) => {
  const { results, orderColumn, orderDirection, pageSize, searchTerm } = React.useContext(PaginatedUserContext);
  const { fetchUsers } = usePaginatedUsers();

  const reorderHandler = (orderColumn: string, orderDirection: 'asc' | 'desc') => {
    fetchUsers({ currentPage: 1, pageSize, orderColumn, orderDirection, searchTerm });
  };

  return (
    <div className={styles.tableWrapper}>
      <div style={{ height: '90%' }}>
        <Scrollbars className={styles.scrollTable} autoHide={true} universal={true}>
          <Table loading={loading} results={results}>
            <TableHead>
              <HeaderCell
                title="Name"
                scope="col"
                orderField={UserSortingOptions.Name}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="User Type"
                scope="col"
                orderField={UserSortingOptions.UserType}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="Email"
                scope="col"
                orderField={UserSortingOptions.Email}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="Company"
                scope="col"
                orderField={UserSortingOptions.Department}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="Status"
                scope="col"
                orderField={UserSortingOptions.Status}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell title="" />
              <HeaderCell title="" />
            </TableHead>
            <TableBody>
              {!results || results.length === 0 ? (
                <tr>
                  <td>There are no users.</td>
                </tr>
              ) : (
                results.map((results: User, index: number) => {
                  return (
                    <UserEntry
                      key={index}
                      user={results}
                      setErrorMessage={setErrorMessage}
                      setSuccessMessage={setSuccessMessage}
                    />
                  );
                })
              )}
            </TableBody>
          </Table>
        </Scrollbars>
      </div>
    </div>
  );
};

export default UserTable;
